// CHG-1283 / ITER-3408 — "Replay welcome tour" affordance.
//
// Lives in the Settings brand_identity section, sibling to the
// CHG-1271 BrandIdentityPreview. On click: clears both v2-welcome-*
// localStorage flags and reloads the page so the WelcomeTrigger picks
// up the cleared state and re-renders the overlay.
//
// Pure additive — never modifies BrandIdentityPreview itself.

import { clearWelcomeFlags } from "./storage";

export function ReplayWelcomeButton() {
  function onClick() {
    clearWelcomeFlags();
    // Reload so WelcomeTrigger's mount-time isWelcomeNeeded() check
    // re-evaluates with the cleared flags. Direct state push isn't
    // viable: the trigger lives in App.tsx and runs its effect once.
    if (typeof window !== "undefined") {
      window.location.reload();
    }
  }

  return (
    <div
      data-component="replay-welcome"
      style={{
        border: "1px solid var(--color-border-subtle)",
        borderRadius: "var(--radius-md)",
        padding: "12px 16px",
        marginBottom: 16,
        background: "var(--color-bg-subtle)",
        display: "flex",
        flexDirection: "column",
        gap: 6,
      }}
    >
      <div
        style={{
          fontSize: 11,
          color: "var(--color-text-muted)",
          textTransform: "uppercase",
          letterSpacing: "0.06em",
          fontWeight: 600,
        }}
      >
        Welcome tour
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <div style={{ flex: 1, fontSize: 13, color: "var(--color-text)" }}>
          Show the 4-step v2 welcome overlay again on the next page load.
        </div>
        <button
          type="button"
          onClick={onClick}
          data-action="replay-welcome"
          style={{
            padding: "6px 12px",
            fontSize: 12,
            fontWeight: 500,
            border: "1px solid var(--color-border)",
            borderRadius: "var(--radius-sm, 6px)",
            background: "var(--color-surface)",
            color: "var(--color-text)",
            cursor: "pointer",
            fontFamily: "inherit",
          }}
        >
          Replay welcome tour
        </button>
      </div>
    </div>
  );
}
